import type { ArticleContent } from "@/types/article";
import type { Lang } from "@/i18n/languages";
import { articlesEn } from "@/mocks/articles/en";
import { articlesFr } from "@/mocks/articles/fr";
import { articlesDa } from "@/mocks/articles/da";
import { articlesDe } from "@/mocks/articles/de";

export const articlesByLang: Record<Lang, ArticleContent[]> = {
  en: articlesEn,
  fr: articlesFr,
  da: articlesDa,
  de: articlesDe,
};

export function getArticle(lang: Lang, slug: string): ArticleContent | undefined {
  return articlesByLang[lang].find((article) => article.slug === slug);
}

export function getArticleSlugs(): string[] {
  return articlesEn.map((article) => article.slug);
}